import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const AdminRedirect = () => {
  useEffect(() => {
    // Redirect to admin panel after a brief moment
    const timer = setTimeout(() => {
      window.location.href = '/glam-admin/';
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
      bgcolor="background.default"
    >
      <CircularProgress size={60} sx={{ mb: 3 }} />
      <Typography variant="h5" gutterBottom>
        Welcome to Glammify
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Redirecting to admin panel...
      </Typography>
    </Box>
  );
};

export default AdminRedirect; 